<template>
  <div class="line-share">
    <!-- <div class="mask"></div>
    <img src="./images/bg.png" alt="" class="bg" /> -->
    <h1>nicee開黑 分享</h1>
    <div class="main">
      <div class="content">
        <img :src="coverUrl" alt="" class="voice-room-bg" />
        <div class="user-detail">
          <img :src="avatarUrl" alt="" class="head-portrait" />
          <span class="user-name">{{ userName }}</span>
        </div>
        <div class="room-name">{{ roomName }}</div>
        <div class="button" @click="toApp()">一起开黑</div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'LineShare',
  props: {},
  data() {
    return {
      roomName: '',
      userName: '',
      avatarUrl: '',
      coverUrl: '',
      roomId: '',
      roomType: '',
      gameType: '',
      gameId: ''
    };
  },
  watch: {},
  computed: {},
  methods: {
    // 初始化根字体大小
    initHtmlFontSize() {
      const html = document.getElementsByTagName('html')[0];
      this.htmlOriginalFontSize = html.style.fontSize;
      html.style.fontSize = '3.2vw'; //设计稿宽375 根字体12px
    },
    // 重置根字体大小
    resetHtmlFontSize() {
      const html = document.getElementsByTagName('html')[0];
      html.style.fontSize = this.htmlOriginalFontSize;
    },
    toApp() {
      if (this.shareUrl) {
        console.log(this.shareUrl);
        window.location.href = this.shareUrl;
      }
      setTimeout(() => {
        this.$confirm({
          content: '您手機是否還未安裝app？',
          title: '提示',
          showCancelButton: true,
          confirmButtonText: '未安裝',
          closeOnClickModal: false,
          cancelButtonText: '已安裝'
        }).then(() => {
          this.$util.jumpAppStore();
          this.$confirm({
            title: '',
            message: '請在下載安裝應用成功後重試。',
            confirmButtonText: '確定',
            customClass: 'dialog-center',
            showCancelButton: false
          });
        });
      }, 3000);
    },
    init() {
      const {
        roomName,
        userName,
        avatarUrl,
        coverUrl,
        roomId,
        roomType,
        gameType,
        gameId
      } = this.$route.query;
      this.shareUrl = `biz.social.weakapp://room?roomId=${roomId}&roomType=${roomType}&roomName=${roomName}&gameId=${gameId}&gameType=${roomType}&avatarUrl=${avatarUrl}`;
      this.roomName = roomName;
      this.userName = userName;
      this.avatarUrl = avatarUrl;
      this.coverUrl = coverUrl;
      this.roomId = roomId;
      this.roomType = roomType;
      this.gameType = gameType;
      this.gameId = gameId;
    }
  },
  created() {
    this.initHtmlFontSize();
    this.init();
  }
};
</script>
<style lang="scss" scoped>
.line-share {
  position: relative;
  width: 100vw !important;
  height: 100vh;
  overflow: auto;
  background-color: #271e64;
  display: flex;
  flex-direction: column;
}
// .bg {
//   position: absolute;
//   width: 100%;
//   height: 100%;
//   left: 0px;
//   top: 0px;
//   object-fit: cover;
// }
// .mask {
//   /* Rectangle 113690 */
//   position: absolute;
//   width: 100%;
//   height: 100%;
//   left: 0px;
//   top: 0px;
//   background: linear-gradient(
//     180deg,
//     rgba(124, 31, 126, 0.62) 0%,
//     rgba(173, 35, 176, 0.24) 100%,
//     rgba(173, 35, 176, 0.34) 100%
//   );
//   z-index: 2;
// }
h1 {
  height: 4rem;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: white;
  font-size: 1.4rem;
}
.main {
  //   position: absolute;
  //   z-index: 3;
  width: 100%;
  height: 1px;
  flex: auto;
  overflow: auto;
}

.content {
  width: 26rem;
  min-height: 38rem;
  border-radius: 20px;
  background-color: white;
  overflow: hidden;
  position: absolute;
  left: 50%;
  top: 10rem;
  transform: translateX(-50%);
  display: flex;
  align-items: center;
  flex-direction: column;
  .voice-room-bg {
    width: 100%;
    height: 22rem;
    object-fit: cover;
  }
  .user-detail {
    margin-top: -4rem;
    width: 100%;
    display: flex;
    align-items: center;
  }
  .head-portrait {
    width: 9rem;
    height: 9rem;
    border-radius: 50%;
    object-fit: cover;
    border: 0.2rem solid white;
    margin-left: 2rem;
  }
  .user-name {
    margin: 3.2rem 2rem 0 2rem;
    font-size: 1.4rem;
  }
  .room-name {
    font-size: 2rem;
    margin-top: 1rem;
    text-align: center;
  }
  .button {
    width: 16rem;
    height: 3rem;
    text-align: center;
    background: #ff6692;
    border-radius: 2rem;
    color: white;
    line-height: 3rem;
    font-size: 1.2rem;
    margin-top: 2rem;
  }
}
</style>
